import React, { Component } from 'react'
import Panel from 'react-bootstrap/lib/Panel'
import { Form } from 'react-redux-form/immutable'

import InputSelect from 'components/InputSelect'

import ByDate from './by-date'
import ByOR from './by-or'

const by = [
  { label: 'By Date', value: 'date' },
  { label: 'By OR Range', value: 'or' },
]

const fund = [
  { label: 'All', value: '' },
  { label: 'STF', value: 'STF' },
  { label: 'TF', value: 'TF' },
  { label: 'GF', value: 'GF' },
]

class Side extends Component {

  _renderFromTo() {
    const { filters } = this.props
    if (filters.get('by') === 'date') {
      return <ByDate />
    } else {
      return <ByOR />
    }
  }

  render() {
    const { cashiers, onSubmit, pending } = this.props

    return (
      <Panel header="Report Criteria">
        <Form model="collectionState" className="form-criteria" onSubmit={onSubmit}>
          <div className="form-group">
            <InputSelect
              model=".by"
              label="By:"
              options={by}
              clearable={false}
            />
          </div>
          {this._renderFromTo()}
          <div className="form-group">
            <InputSelect
              model=".fund"
              label="Fund:"
              options={fund}
              clearable={false}
            />
          </div>
          <div className="form-group">
            <InputSelect
              model=".cashier_id"
              label="Cashier:"
              placeholder="All Cashier"
              options={cashiers}
            />
          </div>
          <hr />
          <button disabled={pending} className="btn btn-info btn-block">Retrieve Data</button>
        </Form>
      </Panel>
    )
  }
}

export default Side



// WEBPACK FOOTER //
// ./src/containers/Reports/Collections/side.js